/**
 * Envelope estándar del backend nuevo de TPV: `{ code, status, message, error }`
 * (más `data` con el payload real). Ver TPV_API.md.
 *
 * SEGURIDAD: `error` es detalle interno para LOGS del backend. Aunque el backend
 * normalmente no lo devuelve, si llegara, NUNCA se muestra al usuario (regla
 * CLAUDE.md: solo mensajes genéricos traducidos).
 */
export interface TpvEnvelope<T> {
  code?: number;
  status?: string;
  message?: string;
  error?: unknown;
  data?: T;
  /** Payload de éxito según TPV_API.md v1 (`{code,status,message,error}` + `extra_data`). */
  extra_data?: T;
}

/**
 * Extrae el payload del envelope. Tolera tres formas del backend:
 *  - `{ ..., extra_data: T }` → devuelve `extra_data` (forma de éxito del spec v1)
 *  - `{ ..., data: T }`       → devuelve `data`
 *  - `T` pelado (sin envelope) → lo devuelve tal cual
 */
export function unwrapTpv<T>(resp: TpvEnvelope<T> | T): T {
  const env = resp as TpvEnvelope<T>;
  if (env && typeof env === 'object') {
    if ('extra_data' in env && env.extra_data !== undefined) return env.extra_data as T;
    if ('data' in env && env.data !== undefined) return env.data as T;
  }
  return resp as T;
}
